import Button from '@eduzz/houston-ui/Button';
import Typography from '@eduzz/houston-ui/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import React from 'react';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import { numberToBRL } from 'v2/helpers/money';

import { THEME_COLORS } from './constants';
import styles from './styles';

import type { Props } from './constants';

function ValueCard({
  id,
  title,
  isLoading,
  value,
  valueTheme,
  hint,
  isCtaDisabled = false,
  ctaCopy,
  ctaButtonTooltip,
  ctaCallback,
  ctaAccessControl = '',
  bottomExtra,
}: Props) {
  const classes = styles();

  const valueClass = valueTheme === THEME_COLORS.SUCCESS ? classes.colorSuccess : classes.colorDefault;

  const renderCtaButton = () => {
    const ctaButton = () => (
      <Button className={classes.cta} variant='contained' onClick={ctaCallback} disabled={isCtaDisabled}>
        {ctaCopy}
      </Button>
    );

    if (ctaButtonTooltip)
      return (
        <Tooltip title={ctaButtonTooltip} placement='top'>
          {ctaButton()}
        </Tooltip>
      );
    return ctaButton();
  };

  return (
    <div id={id} className={classes.root}>
      <div className={classes.main}>
        <div>
          <Typography className={classes.title}>{title}</Typography>
          <Tooltip title={hint} placement='right-start'>
            <HelpOutlineIcon fontSize='small' />
          </Tooltip>
        </div>

        <div className={classes.valueButtonWrapper}>
          <Typography className={valueClass} size='sm'>
            <span className={classes.value}>{!!isLoading || typeof value !== 'number' ? '-' : numberToBRL(value)}</span>
          </Typography>

          {!!ctaCopy && !!ctaCallback && <PermissionHide action={ctaAccessControl}>{renderCtaButton()}</PermissionHide>}
        </div>
      </div>

      {!!bottomExtra && <div className={classes.extra}>{bottomExtra}</div>}
    </div>
  );
}

export default ValueCard;
